<template>
    <el-carousel arrow="never" style="height: 100vh;" indicator-position="none" :interval="3000">
        <el-carousel-item v-if="ModelId.includes('1')">

            <BranchSale ref="sale" />
        </el-carousel-item>
        <el-carousel-item v-if="ModelId.includes('2')">
            <SalesPerformance ref="per" />
        </el-carousel-item>
        <el-carousel-item v-if="ModelId.includes('3')">
            <ItemPromotion ref="item" :PSmartScreenId="SmartScreenId" />
        </el-carousel-item>
    </el-carousel>
</template>
<script>
import BranchSale from '../Branch/BranchSale.vue'
import SalesPerformance from '../SalesPerformance/SalesPerformance.vue'
import ItemPromotion from '../Item/ItemPromotion.vue'

export default {
    name: 'CarouselView',
    components: { BranchSale, SalesPerformance, ItemPromotion },
    data() {
        return {
            handleFullscreenChange: {},
            showPer: true,
            SmartScreenId: 0,
            ModelId: [1, 2, 3]
        }
    },
    mounted() {
        //接收路由参数
        this.SmartScreenId = Number(this.$route.query.SmartScreenId);
        // let ModelId = this.$route.query.ModelId
        // if (ModelId) {
        //     this.ModelId = ModelId.split(',')
        // }
        this.ModelId = this.$route.query.ModelId.split(',')
        console.log('model',this.ModelId)


        this.handleFullscreenChange = setTimeout(() => { // 延迟执行，避免组件未挂载完成
            if (this.ModelId.includes('1')) {
                this.$refs.sale.handleFullscreenChange()

            }
            if (this.ModelId.includes('2')) {
                this.$refs.per.handleFullscreenChange()
            }
        }, 500)
    },
    beforeDestroy() {
        // 移除事件监听器，防止内存泄漏

        clearTimeout(this.handleFullscreenChange)
    },
}
</script>
<style scoped>
.carousel-container {
    width: 100%;
    height: auto;
    /* 确保父容器有合适的高度 */
}

.el-carousel {
    width: 100%;
}
</style>